export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/service-providers', 'admin.service-providers')
    .when('/admin/service-providers/:id/overview', 'admin.service-provider-verification-overview')
    .when('/admin/service-providers/:id/verification/bicycle-shop', 'admin.service-provider-bicycle-shop-verification')
    .when('/admin/service-providers/:id/verification/mobile-shop', 'admin.service-provider-mobile-shop-verification')
    .when('/admin/service-providers/:id/verification/individual', 'admin.service-provider-individual-verification')
    .when('/admin/service-providers/:id/verification/redirect/:step', 'admin.service-provider-verification-redirection')

    .within('admin')

    .segment('service-providers', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.service_providers'
      }],
      template: '<admin-service-providers-list-page></admin-service-providers-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-providers-list.module" */ "./list/admin-service-providers-list.module");
      }
    })
    .segment('service-provider-verification-overview', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.service_providers',
          url: '/admin/service-providers'
        },
        {
          label: 'admin.breadcrumb.service_provider_verification_overview',
        }
      ],
      template: '<admin-service-provider-verification-overview-page></admin-service-provider-verification-overview-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-verification-overview.module" */ "./verification-overview/admin-service-provider-verification-overview.module");
      }
    })
    .segment('service-provider-bicycle-shop-verification', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.service_providers',
          url: '/admin/service-providers'
        },
        {
          label: 'admin.breadcrumb.service_provider_verification_overview',
          url: '/admin/service-providers/:id/overview',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.bicycle_shop_verification',
        }
      ],
      template: '<admin-service-provider-bicycle-shop-verification-page></admin-service-provider-bicycle-shop-verification-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-bicycle-shop-verification.module" */ "./bicycle-shop-verification/admin-service-provider-bicycle-shop-verification.module");
      }
    })
    .segment('service-provider-mobile-shop-verification', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.service_providers',
          url: '/admin/service-providers'
        },
        {
          label: 'admin.breadcrumb.service_provider_verification_overview',
          url: '/admin/service-providers/:id/overview',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.mobile_shop_verification',
        }
      ],
      template: '<admin-service-provider-mobile-shop-verification-page></admin-service-provider-mobile-shop-verification-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-mobile-shop-verification.module" */ "./mobile-shop-verification/admin-service-provider-mobile-shop-verification.module");
      }
    })
    .segment('service-provider-individual-verification', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.service_providers',
          url: '/admin/service-providers'
        },
        {
          label: 'admin.breadcrumb.service_provider_verification_overview',
          url: '/admin/service-providers/:id/overview',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.individual_verification',
        }
      ],
      template: '<admin-service-provider-individual-verification-page></admin-service-provider-individual-verification-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-individual-verification.module" */ "./individual-verification/admin-service-provider-individual-verification.module");
      }
    })
    .segment('service-provider-verification-redirection', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.service_providers',
          url: '/admin/service-providers'
        },
        {
          label: 'admin.breadcrumb.service_provider_verification_overview',
          url: '/admin/service-providers/:id/overview'
        }
      ],
      template: '<admin-service-provider-verification-redirection-page></admin-service-provider-verification-redirection-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-provider-verification-redirection.module" */ "./verification-redirection/admin-service-provider-verification-redirection.module");
      }
    })
  ;
}
